import type { Brand } from "./types";

/**
 * 品牌里的「外置件」取值(W3 C-F):深色 logo、协议外链、公安备案、登录页标语。
 * 纯函数,组件 / 非组件都能用;空值一律回落直营行为(DEFAULT 这几项全空 = 页面零变化)。
 */

/** 工信部 ICP 备案查询。 */
export const ICP_BEIAN_URL = "https://beian.miit.gov.cn";
/** 公安部网安备案查询。 */
export const POLICE_BEIAN_URL = "https://beian.mps.gov.cn/#/query/webSearch";

/** 当前皮肤是深色(cyber)时优先 logoDarkUrl,没配就用 logoUrl。 */
export function pickBrandLogo(
  brand: Pick<Brand, "logoUrl" | "logoDarkUrl">,
  dark: boolean
): string | null {
  if (dark && brand.logoDarkUrl) return brand.logoDarkUrl;
  return brand.logoUrl ?? null;
}

export type LegalKind = "terms" | "privacy";

/**
 * 协议链接:品牌配了外链(已在 normalize 里只收 http/https)→ 新窗口外链;否则站内 /legal/*。
 */
export function legalLink(
  brand: Pick<Brand, "termsUrl" | "privacyUrl">,
  kind: LegalKind
): { href: string; external: boolean } {
  const url = kind === "terms" ? brand.termsUrl : brand.privacyUrl;
  if (url) return { href: url, external: true };
  return { href: `/legal/${kind}`, external: false };
}
